unit unit_EinzelMitteilung;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, DB, Vcl.Controls, WEBLib.Grids, strutils,
  XData.Web.JsonDataset, XData.Web.Dataset, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, WEBLib.WebCtrls, XData.Web.Client,system.types;

type
  TEinzelMitteilung = class(TForm)
    xdsKonversation: TXDataWebDataSet;
    sourcekonversation: TDataSource;
    btnSenden: TButton;
    btnErledigt: TButton;
    btnzurueck: TButton;
    xdsKonversationFromPersonalnummer: TXDataWebEntityField;
    xdsKonversationID: TStringField;
    xdsKonversationDatum: TDateTimeField;
    xdsKonversationFromNachname: TStringField;
    xdsKonversationFromVorname: TStringField;
    xdsKonversationBetreff: TStringField;
    xdsKonversationNotiz: TStringField;
    xdsKonversationUrsprung: TStringField;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    xdsKonversationFromPersonalnummerPersonalnummer: TIntegerField;
    edtNotiz: TMemo;
    WClient: TXDataWebClient;
    xdsMitteilung: TXDataWebDataSet;
    xdsMitteilungMSGBoardID: TXDataWebEntityField;
    xdsMitteilungMSGBoardIDFromPersonalnummer: TXDataWebEntityField;
    xdsMitteilungMSGBoardIDID: TStringField;
    xdsMitteilungMSGBoardIDDatum: TDateTimeField;
    xdsMitteilungMSGBoardIDFromNachname: TStringField;
    xdsMitteilungMSGBoardIDFromVorname: TStringField;
    xdsMitteilungMSGBoardIDBetreff: TStringField;
    xdsMitteilungMSGBoardIDNotiz: TStringField;
    xdsMitteilungToPersonalnummer: TXDataWebEntityField;
    xdsMitteilungToPersonalnummerPersonalnummer: TIntegerField;
    xdsMitteilungMSGBoardSubID: TStringField;
    xdsMitteilungToNachname: TStringField;
    xdsMitteilungToVorname: TStringField;
    xdsMitteilungDatumGelesen: TDateTimeField;
    xdsMitteilungDatumErledigt: TDateTimeField;
    xdsMitteilungMSGBoardIDFromPersonalnummerPersonalnummer: TIntegerField;
    btnSendenErledigt: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure xdsKonversationAfterOpen(DataSet: TDataSet);
    procedure btnSendenClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure btnErledigtClick(Sender: TObject);
    procedure btnzurueckClick(Sender: TObject);
    procedure xdsMitteilungAfterOpen(DataSet: TDataSet);
    procedure xdsMitteilungAfterPost(DataSet: TDataSet);
    procedure xdsMitteilungAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure btnSendenErledigtClick(Sender: TObject);
  private
    { Private-Deklarationen }
    tmpbetreff:string;
    tmpursprung:string;
    tmpempfaenger:string;
    postErledigt:boolean;
  public
    { Public-Deklarationen }
    MerkerMitteilung:string;
    MerkerMitteilungEdit:string;
    ArtMitteilung:integer;
    EinzelCard:THTMLDiv;

  protected procedure LoadDFMValues; override; end;

var
  EinzelMitteilung: TEinzelMitteilung;

implementation
  uses unit1, unit2, unit_Mitteilungen;
{$R *.dfm}

procedure TEinzelMitteilung.btnErledigtClick(Sender: TObject);
begin
  xdsmitteilung.Edit;
  if xdsMitteilungDatumGelesen.IsNull then xdsMitteilungDatumGelesen.AsDateTime:=date+time;
  xdsMitteilungDatumErledigt.AsDateTime:=date+time;
  posterledigt:=true;
  xdsmitteilung.Post;
end;

procedure TEinzelMitteilung.btnSendenClick(Sender: TObject);
  procedure OnResponse(Response:TXDataClientResponse);
  var
  ergebnis:string;
  begin
    ergebnis:=string(TJSObject(response.Result)['value']);
    if ergebnis='WRONG' then
    begin
      showmessage('Die Mitteilung konnte leider nicht erstellt werden');
    end
    else
    begin
      self.close;
    end;
  end;
begin
  if edtnotiz.text='' then
  begin
    showmessage('Sie haben keinen Text eingegeben');
    exit;
  end;
  WClient.RawInvoke('IServerService.NeueMitteilung',[BenutzerPersonalnummer,tmpEmpfaenger,tmpBetreff,tmpursprung,edtnotiz.text],@OnResponse);
end;

procedure TEinzelMitteilung.btnSendenErledigtClick(Sender: TObject);
begin
  xdsmitteilung.Edit;
  if xdsMitteilungDatumGelesen.IsNull then xdsMitteilungDatumGelesen.AsDateTime:=date+time;
  xdsMitteilungDatumErledigt.AsDateTime:=date+time;
  posterledigt:=false;
  xdsmitteilung.Post;
  btnsendenclick(sender);
end;

procedure TEinzelMitteilung.btnzurueckClick(Sender: TObject);
begin
  xdsKonversation.Close;
  self.close;
end;

procedure TEinzelMitteilung.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
action:=cafree;
end;

procedure TEinzelMitteilung.WebFormShow(Sender: TObject);

var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Konversation</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnErledigt.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  myelement:=container3.ElementHandle;

  if MerkerMitteilungEdit<>'' then
  begin
    xdsMitteilung.Close;
    xdsMitteilung.QueryString:='$expand=MSGBoardID, ToPersonalnummer, MSGBoardID/FromPersonalnummer&$filter=MSGBoardSubID eq '+QuotedStr(MerkerMitteilungEdit);
    xdsMitteilung.Load;
  end;
end;

procedure TEinzelMitteilung.xdsKonversationAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
  Einzelkarte:string;
  rawbetreff:TStringdynArray;
  tempnumber:integer;
begin
  xdskonversation.first;
  i:=0;

  inc(i);
  Einzelkarte:='';
  Einzelkarte:=Einzelkarte+'<div class="card-header bg-warning text-cadia4 "><h4>'+xdsKonversationBetreff.asstring+'</h4></div>';
  EinzelCard:=THTMLDiv.Create(self);
  EinzelCard.ElementID:='card'+inttostr(i);
  EinzelCard.HeightStyle:=ssauto;
  EinzelCard.widthStyle:=ssPercent;
  Einzelcard.WidthPercent:=100;
  EinzelCard.HTML.Text:=Einzelkarte;
  EinzelCard.ElementClassName:='card border-secondary m-1 ';
  myelement:=container2.ElementHandle;
  einzelcard.ParentElement:=myelement;

  while not xdskonversation.eof do
  begin
    inc(i);
    Einzelkarte:='';
    if xdsKonversationFromPersonalnummerPersonalnummer.asstring=Benutzerpersonalnummer then
    begin
      Einzelkarte:=Einzelkarte+'<div class="card-header bg-cadia4 text-white"><small>'+formatdatetime('DD.MM.YYYY hh:mm:ss',xdsKonversationDatum.asdatetime)+trim(xdsKonversationFromVorname.asstring+' '+xdsKonversationFromNachname.asstring)+' ('+xdsKonversationFromPersonalnummerPersonalnummer.asstring+')'+'</small></div>';
    end
    else
    begin
      Einzelkarte:=Einzelkarte+'<div class="card-header bg-cadia2 text-cadia4"><small>'+formatdatetime('DD.MM.YYYY hh:mm:ss',xdsKonversationDatum.asdatetime)+trim(xdsKonversationFromVorname.asstring+' '+xdsKonversationFromNachname.asstring)+' ('+xdsKonversationFromPersonalnummerPersonalnummer.asstring+')'+'</small></div>';
    end;
    Einzelkarte:=Einzelkarte+'<div class="card-body text-cadia4 "><h6>'+ReplaceStr(xdsKonversationNotiz.asstring,#13+#10,'<BR>')+'</h6></div>';
    EinzelCard:=THTMLDiv.Create(self);
    EinzelCard.ElementID:='card'+inttostr(i);
    EinzelCard.HeightStyle:=ssauto;
    EinzelCard.widthStyle:=ssPercent;
    Einzelcard.WidthPercent:=100;
    EinzelCard.HTML.Text:=Einzelkarte;
    EinzelCard.ElementClassName:='card border-secondary m-1 ';
    myelement:=container2.ElementHandle;
    einzelcard.ParentElement:=myelement;
    xdskonversation.next;
  end;
  //Antworten beginnt
  xdskonversation.last;
  if xdsKonversationFromPersonalnummerPersonalnummer.asstring=BenutzerPersonalnummer then
  begin
    btnSenden.visible:=false;
    edtnotiz.Visible:=false;
    btnSendenErledigt.visible:=false;
  end
  else
  begin
    tmpbetreff:=xdsKonversationBetreff.asstring;
    tmpursprung:=xdsKonversationUrsprung.asstring;
    tmpempfaenger:=trim(xdsKonversationFromPersonalnummerPersonalnummer.asstring);
    if leftstr(tmpursprung,5)='00000' then tmpUrsprung:=xdsKonversationID.asstring;
    tmpursprung:=trim(tmpursprung);
    if leftstr(tmpbetreff,3)='AW|' then
    begin
      rawbetreff:=SplitString(tmpbetreff,'|');
      if high(rawbetreff)>1 then
      begin
        tempnumber:=1;
        if TryStrToInt(rawbetreff[1],tempnumber)=true then
        begin
          inc(tempnumber);
          tmpbetreff:='AW|'+inttostr(tempnumber)+'|'+rawbetreff[2];
        end;
      end;
    end
    else
    begin
      tmpbetreff:='AW|1|'+tmpbetreff;
    end;
    btnSenden.visible:=true;
    btnSendenerledigt.Visible:=true;
    edtnotiz.Visible:=true;
    edtnotiz.text:='';
    inc(i);
    Einzelkarte:='';

    Einzelkarte:=Einzelkarte+'<div class="card-header bg-warning text-cadia4 "><h4>Neue Antwort</h4><small>('+tmpbetreff+')</div>';
    EinzelCard:=THTMLDiv.Create(self);
    EinzelCard.ElementID:='card'+inttostr(i);
    EinzelCard.HeightStyle:=ssauto;
    EinzelCard.widthStyle:=ssPercent;
    Einzelcard.WidthPercent:=100;
    EinzelCard.HTML.Text:=Einzelkarte;
    EinzelCard.ElementClassName:='card border-secondary m-1 ';
    myelement:=container2.ElementHandle;
    einzelcard.ParentElement:=myelement;

    myelement:=einzelcard.ElementHandle;
    edtNotiz.ParentElement:=myelement;
    btnSenden.parentelement:=myelement;
    btnSendenErledigt.ParentElement:=myelement;
  end;
  postErledigt:=false;
  if xdsMitteilungDatumGelesen.asdatetime<encodedate(2000,1,1) then
  begin
    xdsmitteilung.edit;
    xdsMitteilungDatumGelesen.asdatetime:=date+time;
    xdsMitteilung.post;
  end;
end;

procedure TEinzelMitteilung.xdsMitteilungAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
begin
  if info.Records[0].Error<>'' then showmessage(info.Records[0].Error);
  if posterledigt=true then btnzurueckClick(sender);
end;

procedure TEinzelMitteilung.xdsMitteilungAfterOpen(DataSet: TDataSet);
begin
  if MerkerMitteilung<>'' then
  begin
    xdsKonversation.Close;
    xdsKonversation.QueryString:='$expand=FromPersonalnummer&$filter=(Ursprung eq '+MerkerMitteilung+') OR (ID eq '+MerkerMitteilung+')&$orderby=Datum';
    xdskonversation.Load;
  end;
end;

procedure TEinzelMitteilung.xdsMitteilungAfterPost(DataSet: TDataSet);
begin
  xdsMitteilung.ApplyUpdates;
end;

procedure TEinzelMitteilung.LoadDFMValues;
begin
  inherited LoadDFMValues;

  btnSenden := TButton.Create(Self);
  btnErledigt := TButton.Create(Self);
  btnzurueck := TButton.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  edtNotiz := TMemo.Create(Self);
  btnSendenErledigt := TButton.Create(Self);
  xdsKonversation := TXDataWebDataSet.Create(Self);
  xdsKonversationFromPersonalnummer := TXDataWebEntityField.Create(Self);
  xdsKonversationID := TStringField.Create(Self);
  xdsKonversationDatum := TDateTimeField.Create(Self);
  xdsKonversationFromNachname := TStringField.Create(Self);
  xdsKonversationFromVorname := TStringField.Create(Self);
  xdsKonversationBetreff := TStringField.Create(Self);
  xdsKonversationNotiz := TStringField.Create(Self);
  xdsKonversationUrsprung := TStringField.Create(Self);
  xdsKonversationFromPersonalnummerPersonalnummer := TIntegerField.Create(Self);
  sourcekonversation := TDataSource.Create(Self);
  WClient := TXDataWebClient.Create(Self);
  xdsMitteilung := TXDataWebDataSet.Create(Self);
  xdsMitteilungMSGBoardID := TXDataWebEntityField.Create(Self);
  xdsMitteilungMSGBoardIDFromPersonalnummer := TXDataWebEntityField.Create(Self);
  xdsMitteilungMSGBoardIDID := TStringField.Create(Self);
  xdsMitteilungMSGBoardIDDatum := TDateTimeField.Create(Self);
  xdsMitteilungMSGBoardIDFromNachname := TStringField.Create(Self);
  xdsMitteilungMSGBoardIDFromVorname := TStringField.Create(Self);
  xdsMitteilungMSGBoardIDBetreff := TStringField.Create(Self);
  xdsMitteilungMSGBoardIDNotiz := TStringField.Create(Self);
  xdsMitteilungToPersonalnummer := TXDataWebEntityField.Create(Self);
  xdsMitteilungToPersonalnummerPersonalnummer := TIntegerField.Create(Self);
  xdsMitteilungMSGBoardSubID := TStringField.Create(Self);
  xdsMitteilungToNachname := TStringField.Create(Self);
  xdsMitteilungToVorname := TStringField.Create(Self);
  xdsMitteilungDatumGelesen := TDateTimeField.Create(Self);
  xdsMitteilungDatumErledigt := TDateTimeField.Create(Self);
  xdsMitteilungMSGBoardIDFromPersonalnummerPersonalnummer := TIntegerField.Create(Self);

  btnSenden.BeforeLoadDFMValues;
  btnErledigt.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  edtNotiz.BeforeLoadDFMValues;
  btnSendenErledigt.BeforeLoadDFMValues;
  xdsKonversation.BeforeLoadDFMValues;
  xdsKonversationFromPersonalnummer.BeforeLoadDFMValues;
  xdsKonversationID.BeforeLoadDFMValues;
  xdsKonversationDatum.BeforeLoadDFMValues;
  xdsKonversationFromNachname.BeforeLoadDFMValues;
  xdsKonversationFromVorname.BeforeLoadDFMValues;
  xdsKonversationBetreff.BeforeLoadDFMValues;
  xdsKonversationNotiz.BeforeLoadDFMValues;
  xdsKonversationUrsprung.BeforeLoadDFMValues;
  xdsKonversationFromPersonalnummerPersonalnummer.BeforeLoadDFMValues;
  sourcekonversation.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  xdsMitteilung.BeforeLoadDFMValues;
  xdsMitteilungMSGBoardID.BeforeLoadDFMValues;
  xdsMitteilungMSGBoardIDFromPersonalnummer.BeforeLoadDFMValues;
  xdsMitteilungMSGBoardIDID.BeforeLoadDFMValues;
  xdsMitteilungMSGBoardIDDatum.BeforeLoadDFMValues;
  xdsMitteilungMSGBoardIDFromNachname.BeforeLoadDFMValues;
  xdsMitteilungMSGBoardIDFromVorname.BeforeLoadDFMValues;
  xdsMitteilungMSGBoardIDBetreff.BeforeLoadDFMValues;
  xdsMitteilungMSGBoardIDNotiz.BeforeLoadDFMValues;
  xdsMitteilungToPersonalnummer.BeforeLoadDFMValues;
  xdsMitteilungToPersonalnummerPersonalnummer.BeforeLoadDFMValues;
  xdsMitteilungMSGBoardSubID.BeforeLoadDFMValues;
  xdsMitteilungToNachname.BeforeLoadDFMValues;
  xdsMitteilungToVorname.BeforeLoadDFMValues;
  xdsMitteilungDatumGelesen.BeforeLoadDFMValues;
  xdsMitteilungDatumErledigt.BeforeLoadDFMValues;
  xdsMitteilungMSGBoardIDFromPersonalnummerPersonalnummer.BeforeLoadDFMValues;
  try
    Name := 'EinzelMitteilung';
    Width := 218;
    Height := 377;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    btnSenden.SetParentComponent(Self);
    btnSenden.Name := 'btnSenden';
    btnSenden.Left := 67;
    btnSenden.Top := 203;
    btnSenden.Width := 96;
    btnSenden.Height := 25;
    btnSenden.Caption := 'senden';
    btnSenden.ChildOrder := 4;
    btnSenden.ElementClassName := 'btn btn-info m-1 text-left';
    btnSenden.ElementFont := efCSS;
    btnSenden.ElementPosition := epIgnore;
    btnSenden.HeightStyle := ssAuto;
    btnSenden.HeightPercent := 100.000000000000000000;
    btnSenden.WidthStyle := ssAuto;
    btnSenden.WidthPercent := 100.000000000000000000;
    SetEvent(btnSenden, Self, 'OnClick', 'btnSendenClick');
    btnErledigt.SetParentComponent(Self);
    btnErledigt.Name := 'btnErledigt';
    btnErledigt.Left := 67;
    btnErledigt.Top := 234;
    btnErledigt.Width := 96;
    btnErledigt.Height := 25;
    btnErledigt.Caption := 'erledigt setzen';
    btnErledigt.ChildOrder := 4;
    btnErledigt.ElementClassName := 'btn btn-info m-1 text-left';
    btnErledigt.ElementFont := efCSS;
    btnErledigt.ElementPosition := epIgnore;
    btnErledigt.HeightStyle := ssAuto;
    btnErledigt.HeightPercent := 100.000000000000000000;
    btnErledigt.WidthStyle := ssAuto;
    btnErledigt.WidthPercent := 100.000000000000000000;
    SetEvent(btnErledigt, Self, 'OnClick', 'btnErledigtClick');
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 67;
    btnzurueck.Top := 141;
    btnzurueck.Width := 110;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 2;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 5;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    edtNotiz.SetParentComponent(Self);
    edtNotiz.Name := 'edtNotiz';
    edtNotiz.Left := -134;
    edtNotiz.Top := 265;
    edtNotiz.Width := 352;
    edtNotiz.Height := 112;
    edtNotiz.ChildOrder := 29;
    edtNotiz.ElementClassName := 'form-control form-control-sm m-1';
    edtNotiz.ElementFont := efCSS;
    edtNotiz.ElementPosition := epIgnore;
    edtNotiz.HeightPercent := 100.000000000000000000;
    edtNotiz.Lines.BeginUpdate;
    try
      edtNotiz.Lines.Clear;
      edtNotiz.Lines.Add('WebMemo1');
    finally
      edtNotiz.Lines.EndUpdate;
    end;
    edtNotiz.SelLength := 0;
    edtNotiz.SelStart := 0;
    edtNotiz.TabOrder := 5;
    edtNotiz.WidthStyle := ssPercent;
    edtNotiz.WidthPercent := 99.000000000000000000;
    btnSendenErledigt.SetParentComponent(Self);
    btnSendenErledigt.Name := 'btnSendenErledigt';
    btnSendenErledigt.Left := 67;
    btnSendenErledigt.Top := 172;
    btnSendenErledigt.Width := 96;
    btnSendenErledigt.Height := 25;
    btnSendenErledigt.Caption := 'senden und erledigt';
    btnSendenErledigt.ChildOrder := 4;
    btnSendenErledigt.ElementClassName := 'btn btn-info m-1 text-left';
    btnSendenErledigt.ElementFont := efCSS;
    btnSendenErledigt.ElementPosition := epIgnore;
    btnSendenErledigt.HeightStyle := ssAuto;
    btnSendenErledigt.HeightPercent := 100.000000000000000000;
    btnSendenErledigt.WidthStyle := ssAuto;
    btnSendenErledigt.WidthPercent := 100.000000000000000000;
    SetEvent(btnSendenErledigt, Self, 'OnClick', 'btnSendenErledigtClick');
    xdsKonversation.SetParentComponent(Self);
    xdsKonversation.Name := 'xdsKonversation';
    xdsKonversation.AfterOpen := xdsKonversationAfterOpen;
    xdsKonversation.EntitySetName := 'MSGBoard';
    xdsKonversation.Connection := DM2.XDataWebConnection1;
    xdsKonversation.SubpropsDepth := 1;
    xdsKonversation.Left := 93;
    xdsKonversation.Top := 101;
    xdsKonversationFromPersonalnummer.SetParentComponent(xdsKonversation);
    xdsKonversationFromPersonalnummer.Name := 'xdsKonversationFromPersonalnummer';
    xdsKonversationFromPersonalnummer.FieldName := 'FromPersonalnummer';
    xdsKonversationID.SetParentComponent(xdsKonversation);
    xdsKonversationID.Name := 'xdsKonversationID';
    xdsKonversationID.FieldName := 'ID';
    xdsKonversationID.Required := True;
    xdsKonversationID.Size := 38;
    xdsKonversationDatum.SetParentComponent(xdsKonversation);
    xdsKonversationDatum.Name := 'xdsKonversationDatum';
    xdsKonversationDatum.FieldName := 'Datum';
    xdsKonversationFromNachname.SetParentComponent(xdsKonversation);
    xdsKonversationFromNachname.Name := 'xdsKonversationFromNachname';
    xdsKonversationFromNachname.FieldName := 'FromNachname';
    xdsKonversationFromNachname.Size := 40;
    xdsKonversationFromVorname.SetParentComponent(xdsKonversation);
    xdsKonversationFromVorname.Name := 'xdsKonversationFromVorname';
    xdsKonversationFromVorname.FieldName := 'FromVorname';
    xdsKonversationFromVorname.Size := 40;
    xdsKonversationBetreff.SetParentComponent(xdsKonversation);
    xdsKonversationBetreff.Name := 'xdsKonversationBetreff';
    xdsKonversationBetreff.FieldName := 'Betreff';
    xdsKonversationBetreff.Size := 255;
    xdsKonversationNotiz.SetParentComponent(xdsKonversation);
    xdsKonversationNotiz.Name := 'xdsKonversationNotiz';
    xdsKonversationNotiz.FieldName := 'Notiz';
    xdsKonversationNotiz.Size := 255;
    xdsKonversationUrsprung.SetParentComponent(xdsKonversation);
    xdsKonversationUrsprung.Name := 'xdsKonversationUrsprung';
    xdsKonversationUrsprung.FieldName := 'Ursprung';
    xdsKonversationUrsprung.Size := 38;
    xdsKonversationFromPersonalnummerPersonalnummer.SetParentComponent(xdsKonversation);
    xdsKonversationFromPersonalnummerPersonalnummer.Name := 'xdsKonversationFromPersonalnummerPersonalnummer';
    xdsKonversationFromPersonalnummerPersonalnummer.FieldName := 'FromPersonalnummer.Personalnummer';
    sourcekonversation.SetParentComponent(Self);
    sourcekonversation.Name := 'sourcekonversation';
    sourcekonversation.DataSet := xdsKonversation;
    sourcekonversation.Left := 29;
    sourcekonversation.Top := 101;
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 88;
    WClient.Top := 8;
    xdsMitteilung.SetParentComponent(Self);
    xdsMitteilung.Name := 'xdsMitteilung';
    xdsMitteilung.AfterApplyUpdates := xdsMitteilungAfterApplyUpdates;
    xdsMitteilung.AfterOpen := xdsMitteilungAfterOpen;
    xdsMitteilung.AfterPost := xdsMitteilungAfterPost;
    xdsMitteilung.EntitySetName := 'MSGBoardSub';
    xdsMitteilung.Connection := DM2.XDataWebConnection1;
    xdsMitteilung.SubpropsDepth := 2;
    xdsMitteilung.QueryString := '$expand=MSGBoardID, PersonalnummerTo';
    xdsMitteilung.QueryTop := 1;
    xdsMitteilung.Left := 29;
    xdsMitteilung.Top := 173;
    xdsMitteilungMSGBoardID.SetParentComponent(xdsMitteilung);
    xdsMitteilungMSGBoardID.Name := 'xdsMitteilungMSGBoardID';
    xdsMitteilungMSGBoardID.FieldName := 'MSGBoardID';
    xdsMitteilungMSGBoardIDFromPersonalnummer.SetParentComponent(xdsMitteilung);
    xdsMitteilungMSGBoardIDFromPersonalnummer.Name := 'xdsMitteilungMSGBoardIDFromPersonalnummer';
    xdsMitteilungMSGBoardIDFromPersonalnummer.FieldName := 'MSGBoardID.FromPersonalnummer';
    xdsMitteilungMSGBoardIDID.SetParentComponent(xdsMitteilung);
    xdsMitteilungMSGBoardIDID.Name := 'xdsMitteilungMSGBoardIDID';
    xdsMitteilungMSGBoardIDID.FieldName := 'MSGBoardID.ID';
    xdsMitteilungMSGBoardIDID.Size := 38;
    xdsMitteilungMSGBoardIDDatum.SetParentComponent(xdsMitteilung);
    xdsMitteilungMSGBoardIDDatum.Name := 'xdsMitteilungMSGBoardIDDatum';
    xdsMitteilungMSGBoardIDDatum.FieldName := 'MSGBoardID.Datum';
    xdsMitteilungMSGBoardIDFromNachname.SetParentComponent(xdsMitteilung);
    xdsMitteilungMSGBoardIDFromNachname.Name := 'xdsMitteilungMSGBoardIDFromNachname';
    xdsMitteilungMSGBoardIDFromNachname.FieldName := 'MSGBoardID.FromNachname';
    xdsMitteilungMSGBoardIDFromNachname.Size := 40;
    xdsMitteilungMSGBoardIDFromVorname.SetParentComponent(xdsMitteilung);
    xdsMitteilungMSGBoardIDFromVorname.Name := 'xdsMitteilungMSGBoardIDFromVorname';
    xdsMitteilungMSGBoardIDFromVorname.FieldName := 'MSGBoardID.FromVorname';
    xdsMitteilungMSGBoardIDFromVorname.Size := 40;
    xdsMitteilungMSGBoardIDBetreff.SetParentComponent(xdsMitteilung);
    xdsMitteilungMSGBoardIDBetreff.Name := 'xdsMitteilungMSGBoardIDBetreff';
    xdsMitteilungMSGBoardIDBetreff.FieldName := 'MSGBoardID.Betreff';
    xdsMitteilungMSGBoardIDBetreff.Size := 255;
    xdsMitteilungMSGBoardIDNotiz.SetParentComponent(xdsMitteilung);
    xdsMitteilungMSGBoardIDNotiz.Name := 'xdsMitteilungMSGBoardIDNotiz';
    xdsMitteilungMSGBoardIDNotiz.FieldName := 'MSGBoardID.Notiz';
    xdsMitteilungMSGBoardIDNotiz.Size := 255;
    xdsMitteilungToPersonalnummer.SetParentComponent(xdsMitteilung);
    xdsMitteilungToPersonalnummer.Name := 'xdsMitteilungToPersonalnummer';
    xdsMitteilungToPersonalnummer.FieldName := 'ToPersonalnummer';
    xdsMitteilungToPersonalnummerPersonalnummer.SetParentComponent(xdsMitteilung);
    xdsMitteilungToPersonalnummerPersonalnummer.Name := 'xdsMitteilungToPersonalnummerPersonalnummer';
    xdsMitteilungToPersonalnummerPersonalnummer.FieldName := 'ToPersonalnummer.Personalnummer';
    xdsMitteilungMSGBoardSubID.SetParentComponent(xdsMitteilung);
    xdsMitteilungMSGBoardSubID.Name := 'xdsMitteilungMSGBoardSubID';
    xdsMitteilungMSGBoardSubID.FieldName := 'MSGBoardSubID';
    xdsMitteilungMSGBoardSubID.Required := True;
    xdsMitteilungMSGBoardSubID.Size := 38;
    xdsMitteilungToNachname.SetParentComponent(xdsMitteilung);
    xdsMitteilungToNachname.Name := 'xdsMitteilungToNachname';
    xdsMitteilungToNachname.FieldName := 'ToNachname';
    xdsMitteilungToNachname.Size := 40;
    xdsMitteilungToVorname.SetParentComponent(xdsMitteilung);
    xdsMitteilungToVorname.Name := 'xdsMitteilungToVorname';
    xdsMitteilungToVorname.FieldName := 'ToVorname';
    xdsMitteilungToVorname.Size := 40;
    xdsMitteilungDatumGelesen.SetParentComponent(xdsMitteilung);
    xdsMitteilungDatumGelesen.Name := 'xdsMitteilungDatumGelesen';
    xdsMitteilungDatumGelesen.FieldName := 'DatumGelesen';
    xdsMitteilungDatumErledigt.SetParentComponent(xdsMitteilung);
    xdsMitteilungDatumErledigt.Name := 'xdsMitteilungDatumErledigt';
    xdsMitteilungDatumErledigt.FieldName := 'DatumErledigt';
    xdsMitteilungMSGBoardIDFromPersonalnummerPersonalnummer.SetParentComponent(xdsMitteilung);
    xdsMitteilungMSGBoardIDFromPersonalnummerPersonalnummer.Name := 'xdsMitteilungMSGBoardIDFromPersonalnummerPersonalnummer';
    xdsMitteilungMSGBoardIDFromPersonalnummerPersonalnummer.FieldName := 'MSGBoardID.FromPersonalnummer.Personalnummer';
  finally
    btnSenden.AfterLoadDFMValues;
    btnErledigt.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    edtNotiz.AfterLoadDFMValues;
    btnSendenErledigt.AfterLoadDFMValues;
    xdsKonversation.AfterLoadDFMValues;
    xdsKonversationFromPersonalnummer.AfterLoadDFMValues;
    xdsKonversationID.AfterLoadDFMValues;
    xdsKonversationDatum.AfterLoadDFMValues;
    xdsKonversationFromNachname.AfterLoadDFMValues;
    xdsKonversationFromVorname.AfterLoadDFMValues;
    xdsKonversationBetreff.AfterLoadDFMValues;
    xdsKonversationNotiz.AfterLoadDFMValues;
    xdsKonversationUrsprung.AfterLoadDFMValues;
    xdsKonversationFromPersonalnummerPersonalnummer.AfterLoadDFMValues;
    sourcekonversation.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
    xdsMitteilung.AfterLoadDFMValues;
    xdsMitteilungMSGBoardID.AfterLoadDFMValues;
    xdsMitteilungMSGBoardIDFromPersonalnummer.AfterLoadDFMValues;
    xdsMitteilungMSGBoardIDID.AfterLoadDFMValues;
    xdsMitteilungMSGBoardIDDatum.AfterLoadDFMValues;
    xdsMitteilungMSGBoardIDFromNachname.AfterLoadDFMValues;
    xdsMitteilungMSGBoardIDFromVorname.AfterLoadDFMValues;
    xdsMitteilungMSGBoardIDBetreff.AfterLoadDFMValues;
    xdsMitteilungMSGBoardIDNotiz.AfterLoadDFMValues;
    xdsMitteilungToPersonalnummer.AfterLoadDFMValues;
    xdsMitteilungToPersonalnummerPersonalnummer.AfterLoadDFMValues;
    xdsMitteilungMSGBoardSubID.AfterLoadDFMValues;
    xdsMitteilungToNachname.AfterLoadDFMValues;
    xdsMitteilungToVorname.AfterLoadDFMValues;
    xdsMitteilungDatumGelesen.AfterLoadDFMValues;
    xdsMitteilungDatumErledigt.AfterLoadDFMValues;
    xdsMitteilungMSGBoardIDFromPersonalnummerPersonalnummer.AfterLoadDFMValues;
  end;
end;

end.